import { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { AdminLayout } from "./components/layout/AdminLayout";
import { DashboardPage } from "./routes/DashboardPage";
import {
  CandidateDetailPage,
  CandidateSearchPage,
  SampleLayout,
  SearchResultsPage,
} from "./routes/direct-recruiting-sample";
import { ErrorsPage } from "./routes/ErrorsPage";
import { LoginPage } from "./routes/LoginPage";
import { LandingPage } from "./routes/landing";
import { PrivacyPolicyPage } from "./routes/legal/PrivacyPolicyPage";
import { TermsOfServicePage } from "./routes/legal/TermsOfServicePage";
import { TokushohoPage } from "./routes/legal/TokushohoPage";
import { SkillCheckDetailPage } from "./routes/SkillCheckDetailPage";
import { SkillChecksPage } from "./routes/SkillChecksPage";
import { SupportPage } from "./routes/SupportPage";
import { CtoJobPostingPage } from "./routes/sample-job-postings";
import { useAuthStore } from "./stores/auth.store";

function App() {
  const initialize = useAuthStore((state) => state.initialize);

  useEffect(() => {
    initialize();
  }, [initialize]);

  return (
    <BrowserRouter>
      <Routes>
        <Route element={<LandingPage />} path="/" />
        <Route element={<PrivacyPolicyPage />} path="/privacy-policy" />
        <Route element={<TermsOfServicePage />} path="/terms" />
        <Route element={<TokushohoPage />} path="/tokushoho" />
        <Route element={<SupportPage />} path="/support" />
        <Route element={<CtoJobPostingPage />} path="/sample-job-postings/cto" />
        <Route
          element={
            <SampleLayout>
              <CandidateSearchPage />
            </SampleLayout>
          }
          path="/direct-recruiting-sample"
        />
        <Route
          element={
            <SampleLayout>
              <SearchResultsPage />
            </SampleLayout>
          }
          path="/direct-recruiting-sample/results"
        />
        <Route
          element={
            <SampleLayout>
              <CandidateDetailPage />
            </SampleLayout>
          }
          path="/direct-recruiting-sample/candidates/:id"
        />
        <Route element={<LoginPage />} path="/admin/login" />
        <Route
          element={
            <AdminLayout>
              <DashboardPage />
            </AdminLayout>
          }
          path="/admin"
        />
        <Route
          element={
            <AdminLayout>
              <SkillChecksPage />
            </AdminLayout>
          }
          path="/admin/skill-checks"
        />
        <Route
          element={
            <AdminLayout>
              <SkillCheckDetailPage />
            </AdminLayout>
          }
          path="/admin/skill-checks/:jobId"
        />
        <Route
          element={
            <AdminLayout>
              <ErrorsPage />
            </AdminLayout>
          }
          path="/admin/errors"
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
